// EmptyFloorTile is a map tile that shows empty floor space.

import { EmptyFloorTileOrientation, EmptyFloorTileType } from 'app/src/engine/tiles/EmptyFloorTile';
import * as React from 'react';

function getClassNameForType(type: EmptyFloorTileType): string {
	switch (type) {
		case EmptyFloorTileType.Type1:
			return 'EmptyFloorTile-floor--type1';
		case EmptyFloorTileType.Type2:
			return 'EmptyFloorTile-floor--type2';
		case EmptyFloorTileType.Type3:
			return 'EmptyFloorTile-floor--type3';
		case EmptyFloorTileType.Type4:
			return 'EmptyFloorTile-floor--type4';
	}
}

function getClassNameForOrientation(orientation: EmptyFloorTileOrientation): string {
	switch (orientation) {
		case EmptyFloorTileOrientation.Up:
			return 'EmptyFloorTile-floor--up';
		case EmptyFloorTileOrientation.Down:
			return 'EmptyFloorTile-floor--down';
		case EmptyFloorTileOrientation.Left:
			return 'EmptyFloorTile-floor--left';
		case EmptyFloorTileOrientation.Right:
			return 'EmptyFloorTile-floor--right';
	}
}

type Props = {
	type: EmptyFloorTileType;
	orientation: EmptyFloorTileOrientation;
};

export default function EmptyFloorTile({ type, orientation }: Props): React.ReactElement | null {
	const floorClassNames = [
		'EmptyFloorTile-floor',
		getClassNameForType(type),
		getClassNameForOrientation(orientation),
	];
	return (
		<div className="EmptyFloorTile">
			<div key="EmptyFloorTile-floor" className={floorClassNames.join(' ')}></div>,
			<div key="EmptyFloorTile-rivets" className="EmptyFloorTile-rivets"></div>
		</div>
	);
}
